import React from 'react';
// This is a workaround to properly forward the ref to the mocked SignatureCanvas in tests, 
// since react-signature-canvas doesn't forward refs by default and we need to access its methods in our component.
// @ts-ignore - ignore the import error
const SignatureCanvas = require('react-signature-canvas').default || require('react-signature-canvas');

interface SignatureCanvasWrapperProps {
  canvasProps?: React.CanvasHTMLAttributes<HTMLCanvasElement>;
  onEnd?: () => void;
}

export const SignatureCanvasWrapper = React.forwardRef<any, SignatureCanvasWrapperProps>(
  ({ canvasProps, onEnd }, ref) => <SignatureCanvas ref={ref} canvasProps={canvasProps} onEnd={onEnd} />
);